export const SelectPagination = ({ perPage, handlePerPageChange, totalTherapists }) => {
    return (
        <div className="d-flex flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
            <div className="d-flex flex-sm-row  align-items-center gap-2">
                <label htmlFor="perPageSelect" className="mb-0 text-nowrap">Artículos por página:</label>
                <select 
                    id="perPageSelect"
                    className="form-select" 
                    style={{width: 'auto', minWidth: '80px'}}
                    value={perPage} 
                    onChange={handlePerPageChange}
                >
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={75}>75</option>
                </select>
            </div>
        </div>
    );
};